<template>
  <v-container class="{ 'pa-3': $vuetify.breakpoint.smAndUp }">
    <v-layout wrap>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
      <v-flex sm12 md6 offset-md3>
        <v-card
          :loading="loading"
          elevation="4"
          light
          tag="section"
          class="mx-auto"
          min-height="500"
          max-width="450"
        >
          <v-card-title>
            <v-layout align-center justify-space-between>
              <v-flex class="text-center">
                <img
                  :src="appLogo"
                  alt="UII Logo"
                  width="250"
                  style="vertical-align: middle"
                  class="my-3"
                />
                <div class="text-h6 font-weight-bold">{{ $t("login") }}</div>
                <div
                  class="text-h4 font-weight-bold"
                  style="margin-bottom: 165px"
                >
                  {{ this.$t('app_name').split(" ")[0] }}
                  <span class="text-h4 font-weight-bold indigo--text text--darken-4">{{
                    this.$t('app_name').indexOf(" ") === -1
                      ? ""
                      : this.$t('app_name').substring(this.$t('app_name').indexOf(" ") + 1)
                  }}</span>
                </div>
                <div class="ma-3">
                  <v-form
                    v-if="auth_type === 'password'"
                    ref="form"
                    v-model="valid"
                    @submit="login"
                    lazy-validation
                  >
                    <v-text-field
                      id="email"
                      v-model="email"
                      :rules="[
                        (v) => !!v || 'E-mail is required',
                        (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                      ]"
                      label="E-mail"
                      prepend-icon="mdi-email"
                      required
                    ></v-text-field>
                    <v-text-field
                      id="password"
                      v-model="password"
                      :rules="[(v) => !!v || 'E-mail is required']"
                      label="Password"
                      prepend-icon="mdi-lock"
                      type="password"
                      required
                    ></v-text-field>
                    <v-btn
                      :loading="loading"
                      :disabled="loading"
                      @click="login"
                      color="primary"
                      block
                      >Masuk
                    </v-btn>
                  </v-form>
                  <v-btn
                    v-if="auth_type === 'social'"
                    class="mt-3"
                    :loading="loading"
                    :disabled="loading"
                    @click="authProvider('google')"
                    color="indigo darken-4 white--text"
                    block
                    ><v-icon right dark class="mr-3"> mdi-google </v-icon
                    >{{ $t("login_with_google") }}
                  </v-btn>
                  <div class="caption text-center mt-5">
                    {{ app_url }}
                  </div>
                </div>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-actions>
            <v-btn v-if="this.$i18n.locale === 'en'" text color="indigo darken-4" @click="setLocale('id')"> {{ $t("id_lang") }} </v-btn>
            <v-btn v-if="this.$i18n.locale === 'id'" text color="indigo darken-4" @click="setLocale('en')"> {{ $t("en_lang") }} </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data: () => ({
    valid: true,
    loading: false,
    overlay: false,
    app_url: process.env.MIX_APP_URL,
    auth_type: null,
    email: "",
    password: "",
    appLogo: process.env.MIX_APP_LOGO,
  }),
  created() {
    this.$emit("auth", false);
    this.auth_type =
      this.$route.query.type === "password" ? "password" : "social";
  },
  methods: {
    login() {
      this.valid = this.$refs.form.validate();
      if (this.valid) {
        this.loading = true;
        const body = {
          email: this.email,
          password: this.password,
        };
        this.axios
          .post("api/auth/login", body)
          .then((response) => {
            this.afterLogin(response, 'login');
          })
          .catch((err) => console.log(err))
          .finally(() => (this.loading = false));
      }
    },
    authProvider(provider) {
      let self = this;
      this.$auth
        .authenticate(provider)
        .then((response) => {
          self.socialLogin(provider, response);
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },
    socialLogin(provider, response) {
      this.$http
        .post("/api/social/" + provider, response)
        .then((response) => {
          this.afterLogin(response, 'social');
        })
        .catch((err) => {
          console.log({ err: err });
        });
    },
    afterLogin(response, type) {
      this.$emit("auth", true);
      this.$emit("toast", "success", this.$t(response.data.message));
      localStorage.setItem("isAuth", true);
      type == 'social' ?
      localStorage.setItem("user", JSON.stringify(response.data.data)):
      localStorage.setItem("user", JSON.stringify(response.data.user));
      this.$router.push({ name: "welcome", params: {} });
    },
    setLocale(locale) {
      localStorage.setItem("locale", locale);
      location.reload();
    }
  },
};
</script>

<style lang="scss">
.letter-spacing-0 {
  letter-spacing: 0 !important;
}
.text-decoration-none {
  text-decoration: none !important;
}
</style>